import React from "react";
import { createPortal } from "react-dom";
import { Toaster as SonnerToaster } from "sonner";
import { LoaderIcon } from "@components/icons";

export const Toaster: React.FC = () =>
  createPortal(
    <div className="relative z-[9999]">
      <SonnerToaster
        position="top-right"
        className="pointer-events-auto"
        richColors
        toastOptions={{
          className: "!will-change-auto",
        }}
        loadingIcon={<LoaderIcon className="size-5 animate-spin" />}
      />
    </div>,
    document.body,
  );
